<powerbi-report [eventHandlers]="reportEventHandlers" [cssClassName]="reportDivClassName" [ngClass]="fullscreen ? 'embed-fullscreen' : ''" [embedConfig]="reportConfig"></powerbi-report>
<mat-icon mat-icon class="report-fullscreen-icon" svgIcon="acies_embed_fullscreen" (click)="toggleFullscreen()"></mat-icon>

<countdown #cd [config]="countdownConfig" (event)="onTimerFinished($event)"></countdown>
